import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

export type BulletinPrecipRisk = 'none' | 'light' | 'moderate' | 'heavy';

export interface BulletinPrecipRegion {
  name: string;
  coverage: number;
  coverage_10mm?: number;
  coverage_25mm?: number;
  dominant_mm: number;
  max_mm: number;
  risk: BulletinPrecipRisk;
}

export interface BulletinPrecipLayer {
  available?: boolean;
  valid_from: string | null;
  valid_to: string | null;
  image: string | null;
  layer: string | null;
  image_url: string | null;
  regions?: BulletinPrecipRegion[];
}

export interface BulletinTextRiskTag {
  type: 'severe_convection' | 'thunderstorm' | 'gust' | 'high_temperature' | 'fog';
  severity: 'low' | 'medium' | 'high';
  label: string;
}

export interface BulletinTextSignal {
  headline: string;
  summary_text: string;
  forecast_24h: string;
  conditions: {
    precipitation: string;
    cloud: string;
    wind: string;
    temperature: string;
  };
  key_regions: string[];
  risk_tags: BulletinTextRiskTag[];
  trading_notes: string[];
}

export interface ParsedWeatherBulletin {
  date: string;
  source_pdf: string;
  summary: string;
  text_signal?: BulletinTextSignal;
  precip_24h: BulletinPrecipLayer;
  trading_interpretation: string[];
}

export function useLatestParsedWeatherBulletin() {
  return useQuery({
    queryKey: ['weather-bulletin', 'parsed', 'latest'],
    queryFn: async () => {
      const res = await apiClient.get<ParsedWeatherBulletin>('/weather-bulletin/parsed/latest');
      return res.data;
    },
    staleTime: 10 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
